export const CODE_DIVISION_MASK = "000-000";